export const transformPastedLinksToText = (html: string): string => {
  if (!html.includes('<a')) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const anchors = doc.querySelectorAll('a[href]');

  if (anchors.length === 0) return html;

  anchors.forEach(anchor => {
    const href = anchor.getAttribute('href') || '';
    const text = (anchor.textContent || '').trim();

    let replacement: string;

    if (!text || text === href) {
      replacement = href;
    } else {
      replacement = `${text} (${href})`;
    }

    anchor.replaceWith(doc.createTextNode(replacement));
  });

  return doc.body.innerHTML;
};
